import { appBrokerAuthFetch } from "./broker"
import { localDevAuthBypass, localDevRuntimeBypass } from "./dev-bypass"
import { createAuthFetch, type AuthFetch } from "./fetch"

type WebPlatformFetchInput = {
  fetchImpl?: AuthFetch
  getAccessToken?: () => string | null
  getForwardedAccessToken?: () => string | null
  refreshAccessToken?: () => Promise<string | null>
  shouldRefreshMissingForwardedToken?: (input: RequestInfo | URL, init?: RequestInit) => boolean
  env?: Record<string, string | boolean | undefined>
}

export function createWebPlatformFetch(input: WebPlatformFetchInput = {}) {
  const fetchImpl = input.fetchImpl ?? globalThis.fetch.bind(globalThis)
  if (localDevAuthBypass(input.env)) return fetchImpl
  return createAuthFetch({
    fetchImpl,
    getAccessToken: input.getAccessToken ?? appBrokerAuthFetch.getOpenAnalystApiAccessToken,
    getForwardedAccessToken: input.getForwardedAccessToken,
    refreshAccessToken: input.refreshAccessToken ?? appBrokerAuthFetch.refreshOpenAnalystApiAccessToken,
    shouldRefreshMissingForwardedToken:
      input.shouldRefreshMissingForwardedToken ?? (input.getForwardedAccessToken ? () => true : undefined),
    allowLocalDevRuntimeFetch: () => localDevRuntimeBypass(input.env),
  })
}
